import { USER_PROFILE_LIST_COLUMN } from "./actionTypes";

const INIT_STATE = {
  // List User Profile
  list: {
    // items: [],
    // totalCount: 0,
    columnsVisible: {},
    // params: {
    //   sizePerPage: 10,
    //   page: 1,
    //   sort: "-maker_date",
    //   columnFilter: {}, // Column filter
    //   keywords: "", // Input search all
    // },
  },
  loadingList: false,
  errorList: null,
};

const userProfile = (state = INIT_STATE, action) => {
  switch (action.type) {
    // List User Profile
    case USER_PROFILE_LIST_COLUMN:
      const currentColumns = state.list.columnsVisible || {};
      currentColumns[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: { ...state.list, columnsVisible: currentColumns },
      };

    default:
      return state;
  }
};

export default userProfile;
